import { configureWs } from '@ontruck/ontruck-rt-client';
import { openSnackbar } from './base';

import { hardLogout } from 'utils/auth';

import { getAtomicUpdatesHandlers } from 'redux/modules/realtime/atomic-updates';

let _socket;

const forceHardLogout = () => (payload) => {
  hardLogout();
};

const newRelease = (dispatch) => (payload) => {
  if (payload.clear_cache) {
    hardLogout();
  }

  dispatch(
    openSnackbar('Tenemos nueva versión de TMS, ¿La quieres?', null, {
      label: "Si, dame Rock'n Roll",
      callback: () => window.location.reload(),
    })
  );
};

const getUserChannelCallbacks = (dispatch) => {
  return {
    'cache:clear': forceHardLogout(),
    ...getAtomicUpdatesHandlers(dispatch),
  };
};

export const connectWs = () => {
  return (dispatch, getState, config) => {
    const token = getState().user.access_token;
    const userId = getState().me.id;

    if (!config.WS_URL) return;

    configureWs(config.WS_URL, { debug: config.WS_DEBUG, token })([
      {
        channel: 'release:mercury',
        callbacks: {
          'release:mercury': newRelease(dispatch),
        },
      },
      {
        channel: `user:${userId}`,
        callbacks: getUserChannelCallbacks(dispatch),
      },
    ])
      .then((socket) => {
        _socket = socket;
        return socket;
      })
      .catch((err) => {
        throw err;
      });
  };
};

export const disconnectWs = () => {
  return (dispatch) => {
    if (_socket) {
      _socket.disconnect();
      _socket = null;
    }
  };
};
